const defineMainColor = (paramColor: string | null | undefined) => {
  const isNull = !paramColor || paramColor === "null";
  const color = isNull ? "#F58220" : paramColor;
  const el = document;
  el.documentElement.setAttribute("data-color", color);
  const headTag = document.getElementsByTagName("head")[0];
  const styleTag = document.createElement("style");
  styleTag.innerHTML = `
        :root {
            --maincolor: ${color}
        }
  `;
  headTag.appendChild(styleTag);
  const doc = document.documentElement;
  doc.setAttribute("data-color", color);
  doc.style.setProperty("--maincolor", color);
  doc.style.setProperty("--maincolortrans", color + "0f");
};

export default defineMainColor;
